<template>
  <div class="movement-history-list">
    <div v-if="loading" class="text-center py-3">
      <b-spinner small/>
    </div>
    <template v-else-if="entries && entries.length">
      <table class="table table-sm mb-0">
        <thead>
        <tr>
          <th>{{ $t('Date/Time') }}</th>
          <th>{{ $t('User') }}</th>
          <th>{{ $t('Change') }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="entry in displayEntries" :key="entry.uuid">
          <td>{{ entry.created_at | toDateTime }}</td>
          <td>{{ userDisplayName(entry) }}</td>
          <td>
            <span class="text-muted">{{ fromLabel(entry) }}</span>
            <span class="mx-1">→</span>
            <span>{{ toLabel(entry) }}</span>
          </td>
        </tr>
        </tbody>
      </table>
    </template>
    <no-data-available v-else :height="emptyHeight" :message="$t('No movement history yet.')"/>
  </div>
</template>

<script>
  import NoDataAvailable from "@/core/components/common/NoDataAvailable";

  export default {
    name: "MovementHistoryList",
    components: {NoDataAvailable},
    props: {
      entries: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        default: false
      },
      limit: {
        type: Number,
        default: null
      },
      emptyHeight: {
        type: [Number, String],
        default: 5
      }
    },
    computed: {
      displayEntries() {
        if (!this.entries) return [];
        if (this.limit) {
          return this.entries.slice(0, this.limit);
        }
        return this.entries;
      }
    },
    methods: {
      userDisplayName(entry) {
        if (!entry.created_by) {
          return '—';
        }
        return entry.created_by.display_name || entry.created_by.email || '—';
      },
      fromLabel(entry) {
        if (entry.from_location_path) {
          return entry.from_location_path;
        }
        return '—';
      },
      toLabel(entry) {
        if (entry.to_location_path) {
          return entry.to_location_path;
        }
        return '—';
      }
    }
  }
</script>
